import { FC } from "react";
import { DeepMap, FieldError } from "@hookform/error-message/dist/types";
import { LessonTopicPageTextboxModel } from "../../../models/crud/lessontopicpagetextboxes/LessonTopicPageTextboxModel";
import { nameof } from "../../../utils/Helpers";
import { Textbox } from "../Textbox";

type Props = {
    errors: DeepMap<Record<string, any>, FieldError>;
    register: <HTMLTextboxElement>(refOrValidationOptions: HTMLTextboxElement) => void | ((ref: HTMLTextboxElement | null) => void);
};

export const FieldLessonTopicPageTextboxReflectionLabel: FC<Props> = (props: Props) => {
    const { errors, register } = props;

    const nameReflectionLabel = nameof<LessonTopicPageTextboxModel>("ReflectionLabel");

    return (
        <Textbox
            name={nameReflectionLabel}
            label="Reflection label"
            register={register}
            errors={errors}
            helperText="This is the text which will override the default reflection text"
        />
    );
};
